webpackJsonp([213608641307833],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IssueNavigation = function (_React$Component) {
	  _inherits(IssueNavigation, _React$Component);
	
	  function IssueNavigation(props) {
	    _classCallCheck(this, IssueNavigation);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  IssueNavigation.prototype.render = function render() {
	    var _this2 = this;
	
	    var issue_navigation = [{ name: 'moving_image',
	      title: 'moving image' }, { name: 'still_image',
	      title: 'still image' }, { name: 'textz',
	      title: 'textz' }, { name: 'soundz',
	      title: 'soundz' }].map(function (section_metadata, index) {
	      return _this2.props.issue_data[section_metadata.name + '_count'] > 0 ? _react2.default.createElement(
	        'li',
	        { key: index },
	        _react2.default.createElement(
	          'a',
	          { href: '/issue/' + _this2.props.issue_data.issue_date + '/' + section_metadata.name + '/1' },
	          section_metadata.title
	        )
	      ) : null;
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      null,
	      issue_navigation.map(function (item) {
	        return item;
	      })
	    );
	  };
	
	  return IssueNavigation;
	}(_react2.default.Component);
	
	exports.default = IssueNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _issue_navigation = __webpack_require__(40);
	
	var _issue_navigation2 = _interopRequireDefault(_issue_navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Issue = function (_React$Component) {
	  _inherits(Issue, _React$Component);
	
	  function Issue() {
	    _classCallCheck(this, Issue);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  Issue.prototype.render = function render() {
	    var issue_data = this.props.data.themenJson;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'issue' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sideBarLeft' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cover' },
	          _react2.default.createElement(
	            'a',
	            { href: '/issue/' + issue_data.issue_date },
	            'cover'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sections' },
	          _react2.default.createElement(_issue_navigation2.default, { issue_data: issue_data })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'impressum' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/about/' },
	                'about'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/editorial/' },
	                'editorial'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/contact/' },
	                'contact'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'archive' },
	          _react2.default.createElement(
	            'a',
	            { href: '/archive/' },
	            'archive'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'artwork' },
	        _react2.default.createElement('img', { src: '/media/covers/' + issue_data.thema_cover_uri })
	      ),
	      _react2.default.createElement('div', { className: 'nav-and-metadata' })
	    );
	  };
	
	  return Issue;
	}(_react2.default.Component);
	
	exports.default = Issue;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-issue-js-f096528840cb91e0c89c.js